'use client';
import { useEffect, useState } from 'react';
import PostShip from './post-ship';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setPostShipData } from '@/redux/slices/post-ship/postShipSlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflinePostShipProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflinePostShip({ projectId, isOffline }: OfflinePostShipProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadPostShipData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);
          
          if (project?.postShipData) {
            dispatch(setPostShipData(project.postShipData));
          }
        } catch (error) {
          console.error('Error loading post-ship data:', error);
          showErrorToast('Failed to load post-ship configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadPostShipData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          postShipData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Post-ship data saved offline");
      }
    } catch (error) {
      console.error('Error saving post-ship data:', error);
      showErrorToast("Failed to save post-ship data");
    }
  };

  if (isLoading) {
    return <div>Loading post-ship configuration...</div>;
  }

  return (
    <PostShip 
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
} 